import { Slide, ToastContainer } from "react-toastify";
import React from "react";
import { PhosphorInfo, PhosphorWarning, PhosphorCheckCircle } from "components/Atoms/PhosphorIcon";

export const ToastRoot = () => {
  return <ToastContainer
    position="bottom-left"
    autoClose={10000}
    limit={3}
    hideProgressBar={false}
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    draggable={false}
    pauseOnHover
    theme="light"
    transition={Slide}
    icon={({ type }) => {
      switch (type) {
        case "info":
          return <PhosphorInfo />;
        case "error":
          return <PhosphorWarning iconColor="error" />;
        case "success":
          return <PhosphorCheckCircle iconColor="green" />;
        case "warning":
          return <PhosphorWarning iconColor="yellow" />;
        default:
          return null;
      }
    }}
  />
}